import type { MediaInfoLinksItemProjectInfoEngagementAllOf } from './mediaInfoLinksItemProjectInfoEngagementAllOf';
import type { MediaInfoLinksItemProjectInfoEngagementAllOfTwo } from './mediaInfoLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type MediaInfoLinksItemProjectInfoEngagement = MediaInfoLinksItemProjectInfoEngagementAllOf & MediaInfoLinksItemProjectInfoEngagementAllOfTwo;
